import useLocalStorage from 'src/hooks/useLocalStorage.hook'
import { positionType, searchBrandListType, storeMarkerType } from 'src/pages/CouponMapPage'
import { useUnmount } from 'src/hooks/useUnmount.hook'

const useMapLocalStorage = (map?: kakao.maps.Map | null) => {
  const [userInterestBrandList, setUserInterestBrandList] = useLocalStorage<searchBrandListType[]>(
    'user_interest_brand',
    [],
  )

  const [searchBrandList, setSearchBrandList] = useLocalStorage<searchBrandListType[]>(
    'search_brand_list',
    [],
  )

  const [pastMapCenter, setPastMapCenter] = useLocalStorage<positionType | null>(
    'past_map_center',
    null,
  )

  const [storeMarkers, setStoreMarkers] = useLocalStorage<storeMarkerType[]>('store_markers', [])

  const [activeStoreMarkers, setActiveStoreMarkers] = useLocalStorage<storeMarkerType | null>(
    'active_store_markers',
    null,
  )

  const [pastMapLevel, setPastMapLevel] = useLocalStorage<number | null>('past_map_level', 3)

  useUnmount(() => {
    if (map) {
      const position = {
        lat: map?.getCenter()?.getLat() as number,
        lng: map?.getCenter()?.getLng() as number,
      }
      const mapLevel = map?.getLevel() as number

      setPastMapCenter(position)
      setPastMapLevel(mapLevel)
    }
  })

  return {
    userInterestBrandList,
    searchBrandList,
    pastMapCenter,
    storeMarkers,
    pastMapLevel,
    activeStoreMarkers,
    setUserInterestBrandList,
    setSearchBrandList,
    setPastMapCenter,
    setPastMapLevel,
    setStoreMarkers,
    setActiveStoreMarkers,
  }
}

export default useMapLocalStorage
